/*
 * Um acesso de suporte chega a um ginásio no FRAGMENTO do URL (/suporte#t=<token>): o fragmento nunca é enviado ao servidor nem entra nos logs.
 * Aqui só se lê o que o token declara (o servidor valida a assinatura em cada pedido); nada se confia por estar no token sem ser verificado depois.
 */
const CLAIM = {
  id: ['nameid', 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'],
  name: ['unique_name', 'name', 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'],
  email: ['email', 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'],
  role: ['role', 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role'],
};

const pick = (payload, names) => {
  for (const n of names) if (payload[n] !== undefined) return payload[n];
  return undefined;
};

const decodePayload = (token) => {
  const part = String(token || '').split('.')[1];
  if (!part) return null;
  try {
    const b64 = part.replace(/-/g, '+').replace(/_/g, '/');
    const padded = b64 + '='.repeat((4 - (b64.length % 4)) % 4);
    const json = decodeURIComponent(
      atob(padded).split('').map((c) => '%' + c.charCodeAt(0).toString(16).padStart(2, '0')).join(''),
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
};

/** Lê o token de um acesso de suporte e devolve o utilizador de sessão do portal, ou o motivo de não servir. */
export const parseSupportToken = (token, now = Date.now()) => {
  const payload = decodePayload(token);
  if (!payload) return { ok: false, error: 'O acesso de suporte está malformado.' };
  if (String(payload.support) !== 'true') return { ok: false, error: 'Este token não é um acesso de suporte.' };
  const exp = Number(payload.exp) * 1000;
  if (!exp || exp <= now) return { ok: false, error: 'O acesso de suporte expirou. Abra um novo na consola da plataforma.' };
  const tenant = payload.tenant;
  if (!tenant) return { ok: false, error: 'O acesso de suporte não indica o ginásio.' };
  return {
    ok: true,
    user: {
      id: Number(pick(payload, CLAIM.id)) || 0,
      name: pick(payload, CLAIM.name) || 'Suporte',
      email: pick(payload, CLAIM.email) || '',
      role: 'Admin',
      support: true,
      supportInstance: tenant,
      supportExpiresAt: new Date(exp).toISOString(),
    },
  };
};

/** Lê o token do fragmento (#t=…). */
export const tokenFromHash = (hash) => {
  const m = /(?:^#|&)t=([^&]+)/.exec(String(hash || ''));
  return m ? decodeURIComponent(m[1]) : null;
};
